import "core-js/modules/es.symbol";
import "core-js/modules/es.symbol.description";
import "core-js/modules/es.symbol.iterator";
import "core-js/modules/es.array.from";
import "core-js/modules/es.array.iterator";
import "core-js/modules/es.array.slice";
import "core-js/modules/es.function.name";
import "core-js/modules/es.object.assign";
import "core-js/modules/es.object.to-string";
import "core-js/modules/es.regexp.to-string";
import "core-js/modules/es.string.iterator";
import "core-js/modules/web.dom-collections.iterator";
import "core-js/modules/web.url";

var _Icon, _Icon2;

function _defineProperty(obj, key, value) { if (key in obj) { Object.defineProperty(obj, key, { value: value, enumerable: true, configurable: true, writable: true }); } else { obj[key] = value; } return obj; }

function _slicedToArray(arr, i) { return _arrayWithHoles(arr) || _iterableToArrayLimit(arr, i) || _unsupportedIterableToArray(arr, i) || _nonIterableRest(); }

function _nonIterableRest() { throw new TypeError("Invalid attempt to destructure non-iterable instance.\nIn order to be iterable, non-array objects must have a [Symbol.iterator]() method."); }

function _unsupportedIterableToArray(o, minLen) { if (!o) return; if (typeof o === "string") return _arrayLikeToArray(o, minLen); var n = Object.prototype.toString.call(o).slice(8, -1); if (n === "Object" && o.constructor) n = o.constructor.name; if (n === "Map" || n === "Set") return Array.from(n); if (n === "Arguments" || /^(?:Ui|I)nt(?:8|16|32)(?:Clamped)?Array$/.test(n)) return _arrayLikeToArray(o, minLen); }

function _arrayLikeToArray(arr, len) { if (len == null || len > arr.length) len = arr.length; for (var i = 0, arr2 = new Array(len); i < len; i++) { arr2[i] = arr[i]; } return arr2; }

function _iterableToArrayLimit(arr, i) { if (typeof Symbol === "undefined" || !(Symbol.iterator in Object(arr))) return; var _arr = []; var _n = true; var _d = false; var _e = undefined; try { for (var _i = arr[Symbol.iterator](), _s; !(_n = (_s = _i.next()).done); _n = true) { _arr.push(_s.value); if (i && _arr.length === i) break; } } catch (err) { _d = true; _e = err; } finally { try { if (!_n && _i["return"] != null) _i["return"](); } finally { if (_d) throw _e; } } return _arr; }

function _arrayWithHoles(arr) { if (Array.isArray(arr)) return arr; }

import React, { useCallback, useState } from 'react';
import { useTranslation } from 'react-i18next'; // $FlowFixMe: untyped import

import { useDropzone } from 'react-dropzone';
import classnames from 'classnames';
import { Icon } from "./..";
import { Text } from "../../Typography";
import useToggle from "../../../hooks/useToggle";
import CropperModal from './CropperModal';
import emptyPhoto from './img/empty-photo.png';
import styles from './PhotoUploader.scss';
var ACCEPT_FILES = 'image/*';

var PhotoUploader = function PhotoUploader(_ref) {
  var _classnames;

  var src = _ref.src,
      alt = _ref.alt,
      _ref$short = _ref["short"],
      _short = _ref$short === void 0 ? false : _ref$short,
      _ref$isEditable = _ref.isEditable,
      isEditable = _ref$isEditable === void 0 ? false : _ref$isEditable,
      className = _ref.className,
      error = _ref.error,
      _ref$minWidth = _ref.minWidth,
      minWidth = _ref$minWidth === void 0 ? 0 : _ref$minWidth,
      _ref$minHeight = _ref.minHeight,
      minHeight = _ref$minHeight === void 0 ? 0 : _ref$minHeight,
      onChange = _ref.onChange,
      onDelete = _ref.onDelete,
      onError = _ref.onError;

  var _useTranslation = useTranslation(['photoUploader']),
      t = _useTranslation.t;

  var _useToggle = useToggle(false),
      _useToggle2 = _slicedToArray(_useToggle, 2),
      isOpenCropper = _useToggle2[0],
      toggleCropper = _useToggle2[1];

  var _useState = useState(null),
      _useState2 = _slicedToArray(_useState, 2),
      file = _useState2[0],
      setFile = _useState2[1];

  var hasUploadIcon = isEditable && !src;
  var hasActionIcons = isEditable && !!src;
  var hasError = isEditable && !!error;
  var onDrop = useCallback(function (acceptedFiles) {
    if (acceptedFiles[0]) {
      var url = URL.createObjectURL(acceptedFiles[0]);

      if (minWidth > 0 || minHeight > 0) {
        // check image min width/height
        var img = new Image();
        img.src = url;

        img.onload = function () {
          var i18nData = {
            minWidth: minWidth,
            currentWidth: img.naturalWidth,
            minHeight: minHeight,
            currentHeight: img.naturalHeight
          };
          var msg;

          if (minWidth > 0 && img.naturalWidth < minWidth) {
            msg = t('ERROR_MIN_IMAGE_WIDTH', i18nData);
          } else if (minHeight > 0 && img.naturalHeight < minHeight) {
            msg = t('ERROR_MIN_IMAGE_HEIGHT', i18nData);
          }

          if (msg) {
            if (onError) onError(msg);
            URL.revokeObjectURL(url);
          } else {
            setFile(url);
            toggleCropper();
          }
        };
      } else {
        setFile(url);
        toggleCropper();
      }
    }
  }, [toggleCropper, setFile]);

  var _useDropzone = useDropzone({
    accept: ACCEPT_FILES,
    multiple: false,
    onDrop: onDrop
  }),
      getRootProps = _useDropzone.getRootProps,
      getInputProps = _useDropzone.getInputProps,
      isDragActive = _useDropzone.isDragActive;

  var onCropperClose = function onCropperClose() {
    toggleCropper();
    setFile(null);
  };

  var onCropperSave = function onCropperSave(blob, url) {
    if (onChange) {
      onChange(blob, url);
    }

    onCropperClose();
  };

  var handleClick = function handleClick(e) {
    if (hasActionIcons) {
      e.stopPropagation();
    }
  };

  var handleDelete = function handleDelete() {
    setFile(null);

    if (onDelete) {
      onDelete();
    }
  };

  var photo = /*#__PURE__*/React.createElement("img", {
    src: src || emptyPhoto,
    alt: alt,
    className: styles.image
  });
  var calculatedAspectRatio = minWidth > 0 && minHeight > 0 ? minWidth / minHeight : 1;
  var calculatedImagePadding = minWidth > 0 && minHeight > 0 ? minHeight / minWidth * 100 : 100;
  return isEditable ? /*#__PURE__*/React.createElement(React.Fragment, null, /*#__PURE__*/React.createElement("div", Object.assign({}, getRootProps({
    onClick: handleClick
  }), {
    className: classnames(styles.photo, className, (_classnames = {}, _defineProperty(_classnames, styles.clickable, hasUploadIcon), _defineProperty(_classnames, styles.onDragActive, isDragActive), _defineProperty(_classnames, styles.hasError, hasError), _classnames))
  }), /*#__PURE__*/React.createElement("div", {
    className: classnames(styles.containerWrapper, _defineProperty({}, styles.containerWrapper_short, _short)),
    style: _short ? {
      paddingBottom: "".concat(calculatedImagePadding, "%")
    } : {}
  }, /*#__PURE__*/React.createElement("div", {
    className: styles.containerContent
  }, hasActionIcons && /*#__PURE__*/React.createElement("div", {
    className: styles.iconWrap
  }, /*#__PURE__*/React.createElement("div", Object.assign({
    className: styles.reloadWrap
  }, getRootProps()), _Icon || (_Icon = /*#__PURE__*/React.createElement(Icon, {
    name: "reload",
    size: "medium",
    color: "text-inverted"
  })), /*#__PURE__*/React.createElement("input", Object.assign({
    id: "upload-file"
  }, getInputProps()))), onDelete && /*#__PURE__*/React.createElement("div", {
    className: styles.closeWrap,
    onClick: handleDelete
  }, _Icon2 || (_Icon2 = /*#__PURE__*/React.createElement(Icon, {
    name: "close",
    size: "medium",
    color: "text-inverted"
  })))), photo, hasUploadIcon && /*#__PURE__*/React.createElement("div", {
    className: styles.uploadIconWrap
  }, /*#__PURE__*/React.createElement(Icon, {
    name: "upload",
    size: "inherit",
    color: src ? 'text-inverted' : 'icon'
  }), /*#__PURE__*/React.createElement("input", getInputProps()))))), hasError && /*#__PURE__*/React.createElement(Text, {
    color: "fail",
    size: "small"
  }, error), file && /*#__PURE__*/React.createElement(CropperModal, {
    isOpened: isOpenCropper,
    aspectRatio: calculatedAspectRatio,
    fileUrl: file,
    onSave: onCropperSave,
    onCancel: onCropperClose
  })) : /*#__PURE__*/React.createElement("div", {
    className: classnames(styles.photo, className)
  }, /*#__PURE__*/React.createElement("div", {
    className: classnames(styles.containerWrapper, _defineProperty({}, styles.containerWrapper_short, _short)),
    style: _short ? {
      paddingBottom: "".concat(calculatedImagePadding, "%")
    } : {}
  }, /*#__PURE__*/React.createElement("div", {
    className: styles.containerContent
  }, photo)));
};

export default PhotoUploader;